// AUTO-GENERATED by scripts/gen-content-meta.ts — do not edit by hand.
import type { EnServicePillar } from "./types";

const LOADERS: Record<string, () => Promise<EnServicePillar>> = {
  "apostille-poa": () => import("./apostille-poa").then((m) => m.apostillePoa),
  "bank-account-opening": () => import("./bank-account").then((m) => m.bankAccount),
  "boi-application": () => import("./boi-application").then((m) => m.boiApplication),
  "certified-translation": () => import("./certified-translation").then((m) => m.certifiedTranslation),
  "company-registration": () => import("./company-registration").then((m) => m.companyRegistration),
  "dtv-visa": () => import("./dtv-visa").then((m) => m.dtvVisa),
  "expat-relocation-phuket": () => import("./expat-relocation-phuket").then((m) => m.expatRelocationPhuket),
  "fbi-background-check-thailand": () => import("./fbi-background-check-thailand").then((m) => m.fbiBackgroundCheckThailand),
  "hague-apostille-2026": () => import("./hague-apostille-2026").then((m) => m.hagueApostille2026),
  "long-term-visas": () => import("./long-term-visas").then((m) => m.longTermVisas),
  "marriage-abroad-hub": () => import("./marriage-abroad-hub").then((m) => m.marriageAbroadHub),
  "marriage-thailand": () => import("./marriage-thailand").then((m) => m.marriageThailand),
  "medical-concierge-phuket": () => import("./medical-concierge-phuket").then((m) => m.medicalConciergePhuket),
  "mfa-legalization": () => import("./mfa-legalization").then((m) => m.mfaLegalization),
  "notary-e-signature": () => import("./notary-e-signature").then((m) => m.notaryESignature),
  "notary-power-of-attorney-cross-border": () => import("./notary-poa-cross-border").then((m) => m.notaryPoaCrossBorder),
  "notary-public": () => import("./notary-public").then((m) => m.notaryPublic),
  "police-clearance": () => import("./police-clearance").then((m) => m.policeClearance),
  "property-conveyancing": () => import("./property-conveyancing").then((m) => m.propertyConveyancing),
  "property-sale-poa-us": () => import("./property-sale-poa-us").then((m) => m.propertySalePoaUs),
  "retirement-visa": () => import("./retirement-visa").then((m) => m.retirementVisa),
  "smart-visa": () => import("./smart-visa").then((m) => m.smartVisa),
  "sworn-translation-eu": () => import("./sworn-translation-eu").then((m) => m.swornTranslationEu),
  "thai-driving-license": () => import("./thai-driving-license").then((m) => m.thaiDrivingLicense),
  "tm30-90day-reporting": () => import("./tm30-90day").then((m) => m.tm30NinetyDay),
  "trademark-madrid-protocol": () => import("./trademark-madrid").then((m) => m.trademarkMadrid),
  "us-treaty-of-amity": () => import("./us-treaty-amity").then((m) => m.usTreatyAmity),
  "will-inheritance": () => import("./will-inheritance").then((m) => m.willInheritance),
  "work-permit": () => import("./work-permit").then((m) => m.workPermit),
};

export async function loadEnService(slug: string): Promise<EnServicePillar | undefined> {
  const load = LOADERS[slug];
  return load ? await load() : undefined;
}

export const EN_SERVICE_SLUGS = Object.keys(LOADERS);
